import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { useCookieConsent } from "@/contexts/CookieConsentContext";

export const CookieConsent = () => {
  const { consentStatus, acceptCookies, declineCookies } = useCookieConsent();

  // Don't show if consent has already been given or declined
  if (consentStatus !== "pending") return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border shadow-lg animate-in slide-in-from-bottom duration-300">
      <div className="container max-w-7xl mx-auto p-4 md:p-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-2">
              🍪 Používáme cookies
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Tento web používá cookies pro zajištění základní funkčnosti a analytiku návštěvnosti. 
              Více informací najdete v našich{" "}
              <a 
                href="/ochrana-osobnich-udaju" 
                className="text-primary hover:underline font-medium"
              >
                zásadách ochrany osobních údajů
              </a>
              .
            </p>
          </div>
          <div className="flex items-center gap-3 w-full md:w-auto">
            <Button
              variant="outline"
              onClick={declineCookies}
              className="flex-1 md:flex-none"
            >
              Odmítnout
            </Button>
            <Button
              onClick={acceptCookies}
              className="flex-1 md:flex-none"
            >
              Přijmout
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={declineCookies}
              className="shrink-0"
              aria-label="Zavřít"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
